import Vue from 'vue'

// JQuery
window.$ = require('jquery')
window.JQuery = require('jquery')

// Plugins.
require('./plugins/directives')

import Vuetify, {
	VApp, VContent, VNavigationDrawer,
	VToolbar, VToolbarTitle, VToolbarItems, VToolbarSideIcon,
	VFadeTransition,
	VContainer, VLayout, VFlex,
	VCard, VCardTitle, VCardText, VCardActions,
	VSpacer, VDivider,
	VDialog,
	VAlert,
	VBtn,
	VIcon,
	VImg,
	VForm, VTextField, VMenu, VDatePicker, VTextarea, VSelect,
	VExpansionPanel, VExpansionPanelContent,
	VRating,
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
	components: {
		VApp, VContent, VNavigationDrawer,
		VToolbar, VToolbarTitle, VToolbarItems, VToolbarSideIcon,
		VFadeTransition,
		VContainer, VLayout, VFlex,
		VCard, VCardTitle, VCardText, VCardActions,
		VSpacer, VDivider,
		VDialog,
		VAlert,
		VBtn,
		VIcon,
		VImg,
		VForm, VTextField, VMenu, VDatePicker, VTextarea, VSelect,
		VExpansionPanel, VExpansionPanelContent,
		VRating,
	},
	directives: {
		Ripple,
	},
})

import 'vuetify/src/stylus/app.styl'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import axios from 'axios'
Vue.prototype.$http = axios

Vue.prototype.$api = process.env.VUE_APP_API

// App components.
import AppContainer   from '@/components/AppContainer'
import AppImg         from '@/components/AppImg'
import AppContactBtns from '@/components/AppContactBtns'

Vue.component('app-container',    AppContainer)
Vue.component('app-img',          AppImg)
Vue.component('app-contact-btns', AppContactBtns)

import App from './App.vue'

// Vue.config
Vue.config.productionTip = false

// Vue instance.
new Vue({
	render: function (h) { return h(App) },
}).$mount('#app')
